import React from 'react'
import { Constrain } from "../constrain"
import { Box } from "reflexbox/styled-components"
import BlockContent from "@sanity/block-content-to-react"
import { Button } from "../adUnit"
import styled from "styled-components"
import { colors } from "../../styles/variables"

const Section = styled.section`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  box-shadow: 0 0 15px 0 rgba(0,0,0,0.10);
  z-index: 1;
  
  h1 {
    color: ${colors.primary};
    font-size: 48px;
    line-height: 1.15; //56
  }
  
  img {
    margin: 0;
  }
 
  @media (min-width: 40em)  {
    //background-image: url("${props => props.image}");
    
    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      width: 68%;
      background-image: url("${props => props.image}");
      background-position: center;
      background-size: cover;
    }
  
    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 90%;
      z-index: 0;
      background-image: linear-gradient(90deg, #FFFFFF 0%, #FFFFFF 50%, rgba(255,255,255,0.00) 96%);
    }
  }
  
  @media (min-width: 52em) {
    &:after {
      width: 66%;
    }
  }
`

export const Hero = ({ image, heading, content, linkTo, links,shopLink }) =>
  <Section image={image}>
    <Constrain py={[0,10]} px={-3} pb={[2,10]} flexWrap={'wrap'}>
      <Box width={[1,0]}>
        <img src={image} alt={heading} />
      </Box>
      <Box width={[1,2/3,2/5]} py={5} px={3} style={{ zIndex: 1 }}>
        <h1>{heading}</h1>
        <BlockContent blocks={content} />
        {((linkTo && !links) && (linkTo.phoneNumber || linkTo.url || linkTo.page || linkTo.findServices)) &&
          <Button
            href={linkTo.phoneNumber ? `tel:${linkTo.phoneNumber}` : linkTo.url ? linkTo.url : linkTo.findServices ? shopLink : null}
            target={linkTo.url || linkTo.findServices ? '_blank' : null}
            as={(linkTo.phoneNumber || linkTo.url || linkTo.findServices) ? 'a' : null}
            to={linkTo.page && `/${linkTo.page.slug.current}`}
          >
            {linkTo.linkText || 'Learn More'}
          </Button>
        }
        {links &&
          links.map((link, i) => {
            if (link.phoneNumber || link.url || link.page || link.findServices) {
              return (
                <Button
                  key={i}
                  invert={i!==0}
                  href={link.phoneNumber ? `tel:${link.phoneNumber}` : link.url ? link.url : link.findServices ? shopLink : null}
                  target={link.url || link.findServices ? '_blank' : null}
                  as={(link.phoneNumber || link.url || link.findServices) ? 'a' : null}
                  to={link.page && `/${link?.page?.slug?.current}`}
                  style={{
                    marginRight: 30
                  }}
                >
                  {link.linkText || 'Learn More'}
                </Button>
              )
            }
          })
        }
      </Box>
    </Constrain>
  </Section>